import React, { MouseEventHandler } from 'react';
import { Link, LinkProps } from '@cp/ds/src/components/link';
import { IRouter, withRouteHandler, withRouter } from '@cp/shared/router';
import { useIsExternalMode } from './externalMode';

const RoutableLink = ({
  href,
  router,
  disableHover,
  external,
  ...props
}: Omit<LinkProps, 'href'> & { href?: string | URL; router: IRouter }) => {
  const isExternalMode = useIsExternalMode();
  const onExternalClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (href) {
      router.location.href = new URL(href, router.location.origin).toString();
      return;
    }
    props.onClick?.(e);
  };
  const ownerState = {
    disableHover,
    external,
    onClick: isExternalMode && props.target !== '_blank' ? onExternalClick : props.onClick,
  };
  // Do not show links for pages, which referenced to themselves
  if (!href || (typeof href === 'string' ? href.split('#')[0] : href.pathname) === router.location.pathname) {
    if (typeof disableHover === 'undefined') {
      ownerState.disableHover = true;
    }

    const buttonProps = !href
      ? {
          role: 'button',
          tabIndex: 0,
        }
      : undefined;
    return <Link component="span" {...buttonProps} {...props} {...ownerState} />;
  }

  return <Link href={String(href)} {...props} {...ownerState} />;
};

export const RoutedLink = withRouteHandler(withRouter(RoutableLink));
